import type { ToneOverlay } from "../index.js";

// Voz "avoa" en galego: cariño, preocupación, caldo e moita morriña. Como a "dark", é unha
// voz para aliviar o ánimo, así que as súas liñas rotan cada dúas horas (TONE_ROTATE_MS).
// Cada variante conserva os {marcadores} da base.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} preto, ruliña — atento agora mesmo",
    "{hazard} aquí ao lado, meu. Ollo.",
    "{hazard} preto — non me gusta nada. Coidado.",
    "{hazard} preto. Ten coidado, óesme?",
    "{hazard} aquí preto. Non te arredes, eh?",
  ],
  "alert.toast.escalation": [
    "O {hazard} vai a peor, non agardes, faime caso",
    "O {hazard} medra, meu — move xa",
    "{hazard} peor agora. Non sexas testán, vai.",
    "{hazard} espállase. Ai, Deus. Apura.",
  ],
  "alert.toast.inPath": [
    "O {hazard} vén cara a ti — move, ruliña",
    "{hazard} vai cara a ti, meu — vai, vai",
    "{hazard} vén a por ti. Arriba, move!",
    "{hazard} case á porta — sae xa, anda",
  ],
  "alert.toast.allClear": [
    "Todo tranquilo preto de {place}, grazas a Deus",
    "{place} está tranquilo. Senta, respira.",
    "A salvo preto de {place}, meu. Que susto.",
    "Todo ben preto de {place}. Agora bebe auga.",
  ],
  "alert.toast.tap": [
    "Ven, toca aquí — xa che digo eu que facer",
    "Toca, ruliña — guíote eu",
    "Toca aquí. A avoa ten un plan.",
  ],
  "alert.takeover.title": [
    "{hazard} — veña, move, non discutas",
    "{hazard} — arriba! Vai, que vai en serio",
    "{hazard} — cala e move, meu",
  ],
  "alert.takeover.details": "Amósame todo",
  "alert.takeover.dismiss": "Bo, bo, vale",
  "now.status.allClear": [
    "Todo tranquilo, meu.",
    "Tranquilo agora, ruliña.",
    "Todo ben — senta, descansa.",
    "Todo ben. Xa comiches?",
    "Tranquilo, grazas a Deus.",
    "Caladiño. Descansa un pouco.",
    "En paz agora. E abrígate.",
  ],
  "now.status.stayAware": [
    "Atento, eh, meu?",
    "Ollo vivo, ruliña.",
    "Está atento, por min.",
    "Coidado, óesme?",
    "Non te arredes, anda.",
  ],
  "now.status.sub.allClear": [
    "Nada preto agora. Bebe auga.",
    "Todo tranquilo. Comiches algo?",
    "Nada no teu radio. Senta un pouco.",
    "Limpo, ruliña. Respira.",
    "Nada preto. Ponte un chaleco igual.",
  ],
  "now.activity.empty": [
    "Todo quieto. Comiches?",
    "Non pasa nada. Descansa un pouco.",
    "Todo tranquilo. Chama á túa nai, eh?",
    "Nada por aquí. Toma un caldo.",
    "Tranquilo e en calma. Aproveita, meu.",
  ],
  "onboarding.promise.tagline": "Veciños coidando veciños, como en familia.",
  "onboarding.promise.continue": "Entra, entra",
  "onboarding.home.browse": "Só mirando, por agora",
  "you.voice.intro": "Dime como che gusta que che falen, cariño.",
};
